const installmentLoader = document.querySelector(
  ".product__installment-wrapper-loader"
);

let rates = {
  1: 10,
  2: 20,
  3: 27,
  4: 33,
  5: 38,
  6: 40,
  7: 45,
  8: 45,
  9: 50,
  10: 50,
  11: 55,
  12: 55,
};

const data = {
  data: [
    {
      id: "0",
      min_initial_payment: "999000",
      title: 'Престиж "3"',
      months_setup: [
        {
          month: 3,
          margin_percent: 15,
          id: "101",
        },
      ],
    },
    {
      id: "1",
      title: 'Стандарт "6"',
      min_initial_payment: "999000",
      months_setup: [
        {
          month: 6,
          margin_percent: 30,
          id: "202",
        },
      ],
    },
    {
      id: "2",
      title: 'Комфорт "9"',
      min_initial_payment: "999000",
      months_setup: [
        {
          month: 9,
          margin_percent: 35,
          id: "303",
        },
      ],
    },
    {
      id: "3",
      title: 'Эконом "12"',
      min_initial_payment: "999000",
      months_setup: [
        {
          month: 12,
          margin_percent: 40,
          id: "404",
        },
      ],
    },
    {
      id: "4",
      title: "50% / 50%",
      min_initial_payment: 50,
      months_setup: [
        {
          month: 1,
          margin_percent: 0,
          id: "505",
        },
      ],
      min_initial_payment_value_for: "percent",
    },
    // {
    //   "id": '5',
    //   "title": "Оплата в 4 части",
    //   "min_initial_payment": 25,
    //   "months_setup": [
    //     {
    //       "month": 3,
    //       "margin_percent": 10,
    //       "id": "606"
    //     }
    //   ],
    //   "min_initial_payment_value_for": "percent"
    // }
  ],
};

const getPlans = async () => {
  installmentLoader.style.display = "flex";
  // const res = await fetch("https://brostore.uz/apps/macbro/macbro/tariffs");

  // const data = await res.json();
  installmentLoader.style.display = "none";
  const installmentTypesWrapper = document.querySelector(
    ".installment__types-wrapper"
  );

  const plans = data.data;
  console.log("plans: ", plans);
  console.log("data: ", data);
  console.log(plans[0]);
  installmentTypesWrapper.innerHTML = "";
  plans.forEach((data, index) => {
    const div = document.createElement("div");
    const label = document.createElement("label");
    const input = document.createElement("input");
    const inputId = index;
    div.classList.add("form-check");
    label.classList.add("form-check-label");
    label.innerText = data.title;
    label.setAttribute("for", inputId);
    input.type = "radio";
    input.name = "installment";
    input.id = inputId;
    input.checked = index === 2;
    input.classList.add("form-check-input");
    input.dataset["installmentType"] = data.title;

    div.append(label);
    div.append(input);

    installmentTypesWrapper.append(div);
  });

  setDurations(plans[0].months_setup);

  return plans;
};

// -------------------------------------------------------------------------------------------------------------------

// const initInstallment = async () => {
//    const plans = await getPlans()
//   // const plans = [];
//   const firstPaymentInput = document.querySelector("#first-payment-input");
//   const percentageSpan = document.querySelector(".product__percentage");
//   const durationSelect = document.querySelector(".product__calculator--select");
//   const installmentFirstPaymentSection =
//     document.querySelector(".bro__nasiya-main");
//   const installmentTotalPrice = document.querySelector(
//     ".product__installment-total-price"
//   );
//   const installmentMonthlyPrice = document.querySelector(
//     ".product__installment-monthly-price"
//   );
//   const maxFirstPayment = document
//     .querySelector(".max-vznos-price")
//     .innerText.replaceAll(" ", "")
//     .replaceAll("сум", "");

//   const minFirstPaymentElement = document.querySelector(".min-vznos-price");

//   const productPriceInput = document.querySelector("#productPriceInput");
//   const minVznosPercentageElement = document.querySelector(
//     "#min-vznos-percentage"
//   );
//   const minVznos = minVznosPercentageElement.dataset.minvznos;
//   const minVznosPercentage =
//     minVznosPercentageElement.dataset.minvznospercentage;
//   const submitButton = document.querySelector(".product__installment-button");
//   const installmentTypesInput = document.querySelectorAll(".form-check-input");
//   const intendInstallmentWrapper = document.querySelector(".intend-wrapper");
//   const broNasiyaWrapper = document.querySelector(".bro-nasiya-wrapper");
//   let selectedInstallment = plans[0];
//   intendInstallmentWrapper.classList.remove("border");
//   broNasiyaWrapper?.classList.add("border");

//   const getFirstPaymentAndPercentage = (selectedInstallment) => {
//     let minInitialPayment = 0;
//     if (selectedInstallment.min_initial_payment_value_for === "percent") {
//       minInitialPayment = calculatePriceWithPercentage(
//         selectedInstallment.min_initial_payment
//       );
//     } else {
//       minInitialPayment = selectedInstallment.min_initial_payment;
//     }

//     firstPaymentInput.value = minInitialPayment;
//     firstPaymentInput.minlength = minInitialPayment;
//     firstPaymentInput.min = minInitialPayment;
//     firstPaymentInput.placeholder = minInitialPayment;
//     firstPaymentInput.dataset["dataMinvznos"] = minInitialPayment;
//     minFirstPaymentElement.innerText = priceFormatter(minInitialPayment);
//     const percentage = calculatePercentage(minInitialPayment || 0);

//     percentageSpan.innerText = percentage;
//     minVznosPercentageElement.innerText = percentage;
//   };

//   installmentTypesInput.forEach((input) => {
//     input.addEventListener("change", (e) => {
//       intendInstallmentWrapper.classList.remove("border");
//       broNasiyaWrapper.classList.add("border");
//       const selectedInstallmentType = input.dataset.installmentType;
//       selectedInstallment = plans.find(
//         (installment) => selectedInstallmentType === installment.title
//       ) || {
//         title: "intend-installment",
//         min_initial_payment: 0,
//         min_initial_payment_value_for: "percent",
//       };
//       installmentFirstPaymentSection.style.display = "block";
//       getFirstPaymentAndPercentage(selectedInstallment);
//       rates = getPercentages(plans, selectedInstallment.title);
//       setDurations(selectedInstallment.months_setup);
//       calculatePrices();
//     });
//   });

//   const calculatePrices = () => {
//     getFirstPaymentAndPercentage(selectedInstallment);
//     const selectedDuration = durationSelect.value;
//     const percentage = rates[selectedDuration];
//     let productPrice = document
//       .querySelector(".product-price-container .amount")
//       .innerText.replaceAll(" ", "")
//       .replaceAll("сум", "");
//     const discountedPrice = document
//       .querySelector(".product-price-container .amount.discounted")
//       ?.innerText.replaceAll(" ", "")
//       .replaceAll("сум", "");
//     productPrice = parseInt(discountedPrice || productPrice);

//     if (selectedInstallment.min_initial_payment == 25) {
//       const estimatedPrice = (productPrice * 1.10) / 4;
//       firstPaymentInput.value = estimatedPrice;
//       installmentTotalPrice.innerText = `${priceFormatter(
//         estimatedPrice * 4
//       )} сум`;
//       installmentMonthlyPrice.innerText = `${priceFormatter(estimatedPrice)} сум`;
//     } else {
//       const priceAfterDiscount = productPrice - 999000;
//       const extraPrice = (percentage / 100) * priceAfterDiscount;
//       const totalPrice = productPrice + extraPrice - firstPaymentInput.value || 0;
//       const monthlyPrice = totalPrice / selectedDuration;

//       installmentTotalPrice.innerText = `${priceFormatter(
//         productPrice + extraPrice
//       )} сум`;
//       installmentMonthlyPrice.innerText = `${priceFormatter(monthlyPrice)} сум`;
//     }
//   };

//   durationSelect.addEventListener("change", () => {
//     calculatePrices();
//   });

//   firstPaymentInput.addEventListener("blur", (e) => {
//     const value = e.target.value;
//     const minFirstPayment = minFirstPaymentElement.innerText
//       .replaceAll(" ", "")
//       .replaceAll("сум", "");
//     if (parseInt(value) < parseInt(minFirstPayment) || !value) {
//       firstPaymentInput.value = minFirstPayment;
//       const percentage = calculatePercentage(minFirstPayment || 0);

//       percentageSpan.innerText = percentage;
//       calculatePrices();
//     }
//   });

//   firstPaymentInput.addEventListener("input", (e) => {
//     let value = e.target.value;

//     if (parseInt(value) > parseInt(maxFirstPayment)) {
//       firstPaymentInput.value = maxFirstPayment;
//       value = maxFirstPayment;
//     }

//     const percentage = calculatePercentage(value || 0);

//     percentageSpan.innerText = percentage;
//     calculatePrices();
//   });

//   const submitInstallment = () => {
//     const productPrice = document
//       .querySelector(".amount")
//       .innerText.replaceAll(" ", "")
//       .replaceAll("сум", "");
//     const quantity = document.querySelector(".quantity__input");
//     const productId = submitButton.dataset.productid;
//     const handle = submitButton.dataset.handle;
//     const variantTitle = document.querySelector(
//       ".product-variant-title"
//     ).innerText;

//     window.location.href = `${
//       window.location.origin
//     }/pages/rassrochka?product_id=${productId}&product_handle=${handle}&price=${installmentTotalPrice.innerText.replaceAll(
//       " ",
//       ""
//     )}&duration=${durationSelect.value}&inputElement=${
//       firstPaymentInput.value
//     }&monthlyPayment=${installmentMonthlyPrice.innerText.replaceAll(
//       " ",
//       ""
//     )}&quantity=${
//       quantity.value
//     }&productPrice=${productPrice}&selectedInstallmentType=${selectedInstallment.title.replace(
//       "%",
//       ""
//     )}&variant_title=${variantTitle}`;
//   };

//   submitButton.addEventListener("click", () => {
//     if (selectedInstallment.title === "intend-installment") {
//       return intendSubmit();
//     }

//     return submitInstallment();
//   });

//   const renderIntendInstallment = async () => {
//     installmentLoader.style.display = "flex";
//     installmentFirstPaymentSection.style.display = "none";
//     setDurations([{ month: 12 }]);
//     selectedInstallment = {
//       title: "intend-installment",
//       min_initial_payment: 0,
//       min_initial_payment_value_for: "percent",
//     };
//     submitButton.style.opacity = "50%";
//     submitButton.style.cursor = "default";
//     submitButton.disabled = true;
//     let productPrice = document
//       .querySelector(".product-price-container .amount")
//       .innerText.replaceAll(" ", "")
//       .replaceAll("сум", "");
//     const discountedPrice = document
//       .querySelector(".product-price-container .amount.discounted")
//       ?.innerText.replaceAll(" ", "")
//       .replaceAll("сум", "");
//     productPrice = parseInt(discountedPrice || productPrice);

//     const productPriceInTiyin = parseInt(productPrice) * 100;
//     const url = `https://brostore.uz/apps/macbro/intend/calculate?price=${productPriceInTiyin}`;
//     const res = await fetch(url);
//     const data = await res.json();
//     installmentLoader.style.display = "none";
//     const monthlyPrice = data.data.items[0].per_month / 100;
//     const totalPrice = data.data.items[0].price / 100;
//     durationSelect.value = 12;
//     installmentTotalPrice.innerText = `${priceFormatter(totalPrice)} сум`;
//     installmentMonthlyPrice.innerText = `${priceFormatter(monthlyPrice)} сум`;
//     submitButton.style.opacity = "100%";
//     submitButton.style.cursor = "pointer";
//     submitButton.disabled = false;
//   };

//   intendInstallmentWrapper.addEventListener("click", () => {
//     intendInstallmentWrapper.classList.add("border");
//     broNasiyaWrapper.classList.remove("border");
//     renderIntendInstallment();
//     installmentTypesInput.forEach((input) => (input.checked = false));
//   });
//   // remove until line 265
//   intendInstallmentWrapper.classList.add("border");
//   broNasiyaWrapper?.classList.remove("border");
//   renderIntendInstallment();
//   installmentTypesInput.forEach((input) => (input.checked = false));
//   calculatePrices();
//   getFirstPaymentAndPercentage(plans[0]);
// };

// initInstallment();

const initInstallment = async () => {
  const plans = await getPlans();
  const firstPaymentInput = document.querySelector("#first-payment-input");
  const percentageSpan = document.querySelector(".product__percentage");
  const durationSelect = document.querySelector(".product__calculator--select");
  const installmentFirstPaymentSection =
    document.querySelector(".bro__nasiya-main");
  const installmentTotalPrice = document.querySelector(
    ".product__installment-total-price"
  );
  const installmentMonthlyPrice = document.querySelector(
    ".product__installment-monthly-price"
  );
  const maxFirstPayment = document
    .querySelector(".max-vznos-price")
    .innerText.replaceAll(" ", "")
    .replaceAll("сум", "");

  const minFirstPaymentElement = document.querySelector(".min-vznos-price");

  const productPriceInput = document.querySelector("#productPriceInput");
  const minVznosPercentageElement = document.querySelector(
    "#min-vznos-percentage"
  );
  const minVznos = minVznosPercentageElement.dataset.minvznos;
  const minVznosPercentage =
    minVznosPercentageElement.dataset.minvznospercentage;
  const submitButton = document.querySelector(".product__installment-button");
  const installmentTypesInput = document.querySelectorAll(".form-check-input");
  const intendInstallmentWrapper = document.querySelector(".intend-wrapper");
  const broNasiyaWrapper = document.querySelector(".bro-nasiya-wrapper");
  let selectedInstallment = plans[0];
  intendInstallmentWrapper.classList.remove("border");
  broNasiyaWrapper.classList.add("border");
  let productPrice = document
    .querySelector(".product-price-container .amount")
    .innerText.replaceAll(" ", "")
    .replaceAll("сум", "");
  const getFirstPaymentAndPercentage = (selectedInstallment) => {
    let minInitialPayment = 0;
    if (selectedInstallment.min_initial_payment_value_for === "percent") {
      minInitialPayment = calculatePriceWithPercentage(
        selectedInstallment.min_initial_payment
      );
    } else {
      if (productPrice > 15000000) {
        minInitialPayment = productPrice * 0.3;
      } else {
        minInitialPayment = selectedInstallment.min_initial_payment;
      }
    }

    firstPaymentInput.value = minInitialPayment;
    firstPaymentInput.minlength = minInitialPayment;
    firstPaymentInput.min = minInitialPayment;
    firstPaymentInput.placeholder = minInitialPayment;
    firstPaymentInput.dataset["dataMinvznos"] = minInitialPayment;
    minFirstPaymentElement.innerText = priceFormatter(minInitialPayment);
    const percentage = calculatePercentage(minInitialPayment || 0);

    percentageSpan.innerText = percentage;
    minVznosPercentageElement.innerText = percentage;
  };

  installmentTypesInput.forEach((input) => {
    input.addEventListener("change", (e) => {
      intendInstallmentWrapper.classList.remove("border");
      broNasiyaWrapper.classList.add("border");
      const selectedInstallmentType = input.dataset.installmentType;
      selectedInstallment = plans.find(
        (installment) => selectedInstallmentType === installment.title
      ) || {
        title: "intend-installment",
        min_initial_payment: 0,
        min_initial_payment_value_for: "percent",
      };
      installmentFirstPaymentSection.style.display = "block";
      getFirstPaymentAndPercentage(selectedInstallment);
      // rates = getPercentages(plans, selectedInstallment.title);
      setDurations(selectedInstallment.months_setup);
      calculatePrices();
    });
  });

  //   const calculatePrices = () => {
  //   getFirstPaymentAndPercentage(selectedInstallment);
  //   const selectedDuration = durationSelect.value;
  //   const percentage = rates[selectedDuration];
  //   let productPrice = document
  //     .querySelector(".product-price-container .amount")
  //     .innerText.replaceAll(" ", "")
  //     .replaceAll("сум", "");
  //   const discountedPrice = document
  //     .querySelector(".product-price-container .amount.discounted")
  //     ?.innerText.replaceAll(" ", "")
  //     .replaceAll("сум", "");
  //   productPrice = parseInt(discountedPrice || productPrice);

  //   if (selectedInstallment.min_initial_payment == 25) {
  //     const estimatedPrice = (productPrice * 1.10) / 4;
  //     firstPaymentInput.value = estimatedPrice;
  //     installmentTotalPrice.innerText = `${priceFormatter(
  //       estimatedPrice * 4
  //     )} сум`;
  //     installmentMonthlyPrice.innerText = `${priceFormatter(estimatedPrice)} сум`;
  //   } else {
  //     const priceAfterDiscount = productPrice - 999000;
  //     const extraPrice = (percentage / 100) * priceAfterDiscount;
  //     const totalPrice = productPrice + extraPrice - firstPaymentInput.value || 0;
  //     const monthlyPrice = totalPrice / selectedDuration;

  //     installmentTotalPrice.innerText = `${priceFormatter(
  //       productPrice + extraPrice
  //     )} сум`;
  //     installmentMonthlyPrice.innerText = `${priceFormatter(monthlyPrice)} сум`;
  //   }
  // };

  const calculatePrices = () => {
    const selectedDuration = durationSelect.value;
    const percentage = rates[selectedDuration];
    let productPrice = document
      .querySelector(".product-price-container .amount")
      .innerText.replaceAll(" ", "")
      .replaceAll("сум", "");
    const discountedPrice = document
      .querySelector(".product-price-container .amount.discounted")
      ?.innerText.replaceAll(" ", "")
      .replaceAll("сум", "");
    productPrice = parseInt(discountedPrice || productPrice);

    const extraPrice = (percentage / 100) * productPrice;
    const totalPrice = productPrice + extraPrice - firstPaymentInput.value || 0;
    const monthlyPrice = totalPrice / selectedDuration;

    if (selectedInstallment.min_initial_payment == 25) {
      const estimatedPrice = Math.round((productPrice * 1.1) / 4);
      firstPaymentInput.value = estimatedPrice;
      installmentTotalPrice.innerText = `${priceFormatter(
        estimatedPrice * 4
      )} сум`;
      installmentMonthlyPrice.innerText = `${priceFormatter(
        estimatedPrice
      )} сум`;
    } else {
      const priceAfterDiscount = productPrice - 999000;
      const extraPrice = (percentage / 100) * priceAfterDiscount;
      const totalPrice =
        productPrice + extraPrice - firstPaymentInput.value || 0;
      const monthlyPrice = totalPrice / selectedDuration;

      installmentTotalPrice.innerText = `${priceFormatter(
        productPrice + extraPrice
      )} сум`;
      installmentMonthlyPrice.innerText = `${priceFormatter(monthlyPrice)} сум`;
    }
  };

  durationSelect.addEventListener("change", () => {
    calculatePrices();
  });

  firstPaymentInput.addEventListener("blur", (e) => {
    const value = e.target.value;
    const minFirstPayment = minFirstPaymentElement.innerText
      .replaceAll(" ", "")
      .replaceAll("сум", "");
    if (parseInt(value) < parseInt(minFirstPayment) || !value) {
      firstPaymentInput.value = minFirstPayment;
      const percentage = calculatePercentage(minFirstPayment || 0);

      percentageSpan.innerText = percentage;
      calculatePrices();
    }
  });

  firstPaymentInput.addEventListener("input", (e) => {
    let value = e.target.value;

    if (parseInt(value) > parseInt(maxFirstPayment)) {
      firstPaymentInput.value = maxFirstPayment;
      value = maxFirstPayment;
    }

    const percentage = calculatePercentage(value || 0);

    percentageSpan.innerText = percentage;
    calculatePrices();
  });

  const submitInstallment = () => {
    const productPrice = document
      .querySelector(".amount")
      .innerText.replaceAll(" ", "")
      .replaceAll("сум", "");
    const quantity = document.querySelector(".quantity__input");
    const productId = submitButton.dataset.productid;
    const handle = submitButton.dataset.handle;
    window.location.href = `https://brostore.uz/pages/rassrochka?product_id=${productId}&product_handle=${handle}&price=${installmentTotalPrice.innerText.replaceAll(
      " ",
      ""
    )}&duration=${durationSelect.value}&inputElement=${
      firstPaymentInput.value
    }&monthlyPayment=${installmentMonthlyPrice.innerText.replaceAll(
      " ",
      ""
    )}&quantity=${quantity.value}&productPrice=${productPrice}`;
  };

  submitButton.addEventListener("click", () => {
    if (selectedInstallment.title === "intend-installment") {
      return intendSubmit();
    }

    return submitInstallment();
  });

  const renderIntendInstallment = async () => {
    installmentLoader.style.display = "flex";
    installmentFirstPaymentSection.style.display = "none";
    setDurations([{ month: 12 }]);
    selectedInstallment = {
      title: "intend-installment",
      min_initial_payment: 0,
      min_initial_payment_value_for: "percent",
    };
    submitButton.style.opacity = "50%";
    submitButton.style.cursor = "default";
    submitButton.disabled = true;
    let productPrice = document
      .querySelector(".product-price-container .amount")
      .innerText.replaceAll(" ", "")
      .replaceAll("сум", "");
    const discountedPrice = document
      .querySelector(".product-price-container .amount.discounted")
      ?.innerText.replaceAll(" ", "")
      .replaceAll("сум", "");
    productPrice = parseInt(discountedPrice || productPrice);

    const productPriceInTiyin = parseInt(productPrice) * 100;
    const url = `https://macbro.uz/apps/macbro/intend/calculate?price=${productPriceInTiyin}`;
    const res = await fetch(url);
    const data = await res.json();
    installmentLoader.style.display = "none";
    const monthlyPrice = data.data.items[0].per_month / 100;
    const totalPrice = data.data.items[0].price / 100;
    durationSelect.value = 12;
    installmentTotalPrice.innerText = `${priceFormatter(totalPrice)} сум`;
    installmentMonthlyPrice.innerText = `${priceFormatter(monthlyPrice)} сум`;
    submitButton.style.opacity = "100%";
    submitButton.style.cursor = "pointer";
    submitButton.disabled = false;
  };

  intendInstallmentWrapper.addEventListener("click", () => {
    intendInstallmentWrapper.classList.add("border");
    broNasiyaWrapper.classList.remove("border");
    renderIntendInstallment();
    installmentTypesInput.forEach((input) => (input.checked = false));
  });

  calculatePrices();
  getFirstPaymentAndPercentage(plans[0]);
};

initInstallment();
